/** */
import {
  ADD_MANY_DEMOS_TO_STORE,
  ADD_ONE_DEMO_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_DEMOS_TO_STORE,
  REM_ONE_DEMO_FROM_STORE
} from '../actions/demo';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_DEMOS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (demos, demo) => ({
            ...demos,
            [demo.id]: demo
          }),
          {}
        )
      };
    case ADD_ONE_DEMO_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (demos, demo) => ({
            ...demos,
            [demo.id]: demo
          }),
          {}
        )
      };
    case LOAD_DEMOS_TO_STORE:
      return {
        ...payload.reduce(
          (demos, demo) => ({
            ...demos,
            [demo.id]: demo
          }),
          {}
        )
      };
    case REM_ONE_DEMO_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
